import React from 'react';
import { addCommasToNumber } from '../../../../../Utils/CommonUtils';
import { ApiIncomeBracket } from '../types';

interface PlanDropdownProps {
  incomeBrackets: ApiIncomeBracket[];
  discountText: string;
  id: string;
}

export const PlanDropdown: React.FC<PlanDropdownProps> = ({
  incomeBrackets,
  discountText,
  id,
}) => {
  const hasDiscountNumber = discountText;

  const discountTextParts = discountText.split(' ');
  const firstPart = discountTextParts.slice(0, 2).join(' ');
  const restPart = discountTextParts.slice(2).join(' ');

  return (
    <div
      id={id}
      className="w-full mb-4 px-6 py-8"
      role="region"
      aria-live="polite"
    >
      {hasDiscountNumber && (
        <div className="bg-[#FDF2ED] px-4 py-2 mb-4 rounded-md inline-block">
          <span className="text-[#E8743E] font-[600]">{firstPart}</span>{' '}
          <span className="text-[#4B5159] px-2 font-[14px]">{restPart}</span>
        </div>
      )}

      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-grey-300">
            <th className="text-left pb-2 font-semibold">Taxable Income</th>
            <th className="text-right pb-2 font-semibold">Amount</th>
          </tr>
        </thead>
        <tbody>
          {incomeBrackets.map(
            ({ label, originalAmount, discountedAmount }, i) => {
              const originalNum = Math.ceil(Number(originalAmount));
              const discountedNum = Math.ceil(Number(discountedAmount));
              const showOriginal =
                originalAmount && originalNum !== discountedNum;

              return (
                <tr key={i}>
                  <td className="py-2">{label}</td>
                  <td className="py-2 text-right font-semibold">
                    {showOriginal && (
                      <span className="line-through text-grey-400 mr-2">
                        (₹{addCommasToNumber(originalNum)})
                      </span>
                    )}
                    ₹{addCommasToNumber(discountedNum)}
                  </td>
                </tr>
              );
            }
          )}
        </tbody>
      </table>
    </div>
  );
};
